import { useState, useEffect, useRef } from "react";

import WidgetsOutlinedIcon from "@mui/icons-material/WidgetsOutlined";
import { CircularProgress } from "@mui/material";
import { SurveyServices } from "../services/SurveyServices";
import AddIcon from "../assets/addMoreIcon.svg";
import EditIcon from "../assets/editIconWhite.svg";
import SearchIcon from "../assets/searchIcon.svg";
import { handleApiErrorResponses } from "../utils/ApisErrorHandling";
import { Switch } from "@mui/material";
import AddSurveyQuestions from "./AddSurveyQuestions";
import ManageSequence from "./ManageSequence";

import "./ManageSurveyQuestions.scss";
const ManageSurveyQuestions = () => {
  const [loading, setLoading] = useState(false);
  const [questionList, setQuestionList] = useState([]);
  const [addQuestion, setAddQuestion] = useState(false);
  const [manageSequence, setManageSequence] = useState(false);
  const [searchKey, setSearchKey] = useState("");
  const searchTimeRef = useRef();
  const handleSearch = (e) => {
    //debouncing structure
    if (searchTimeRef.current) {
      clearInterval(searchTimeRef.current);
    }
    searchTimeRef.current = setTimeout(() => {
      setSearchKey(e.target.value);
    }, 500);
  };
  const getDate = (dateString) => {
    const date = new Date(dateString);

    // Format the date as DD/MM/YYYY HH:MM
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0"); // months are 0-indexed
    const year = date.getFullYear();
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");

    return `${day}/${month}/${year} ${hours}:${minutes}`;
  };

  const getQuestionList = async () => {
    try {
      const res = await SurveyServices.getSurveyQuestions("", searchKey);
      console.log("response survey questions:", res.data);
      setQuestionList(res?.data?.questions);
    } catch (error) {
      handleApiErrorResponses(error);
    }
  };
  const updateQuestionStatus = async (id, status) => {
    try {
      status = status === "ACTIVE" ? "INACTIVE" : "ACTIVE";
      const res = await SurveyServices.updateSurveyQuestionStatus(id, status);
      await getQuestionList("");
    } catch (error) {
      handleApiErrorResponses(error);
    }
  };

  useEffect(() => {
    getQuestionList();
  }, [searchKey]);
  useEffect(() => {
    const getQuestionsReport = async () => {
      const res = await SurveyServices.getSurveyQuestionsReport();
      console.log("survey report res:", res.data);
    };
    getQuestionsReport();
  }, []);
  return (
    <div className="survey-questions-box">
      {" "}
      <span className="path_line">
        <WidgetsOutlinedIcon style={{ height: "24px" }} /> &nbsp; &nbsp;/ &nbsp;
        &nbsp; Dashboard &nbsp; &nbsp;/ &nbsp; &nbsp; Manage Survey Questions
      </span>
      <div className="flex justify-between items-center">
        <div className="heading">Manage Survey Questions</div>
        <div className="flex gap-2 items-center">
          <div
            style={{ border: "1px solid #E4E4E4" }}
            className="flex items-center gap-2 bg-white rounded-[8px] px-4 py-[6px] "
          >
            <img src={SearchIcon} alt="search-icon" />
            <input
              type="text"
              placeholder="Search anything"
              style={{ border: "0" }}
              className="outline-none"
              onChange={handleSearch}
            />
          </div>
          <div
            className="flex items-center gap-2 text-white font-semibold text-sm bg-[#017C57] uppercase px-8 py-3 rounded-full cursor-pointer"
            onClick={() => setAddQuestion(true)}
          >
            <img src={AddIcon} alt="add-icon" />
            Add
          </div>
          <div
            className="flex items-center gap-2 text-white font-semibold text-sm bg-[#017C57] uppercase px-8 py-3 rounded-full cursor-pointer"
            onClick={() => setManageSequence(true)}
          >
            <img src={EditIcon} alt="edit-icon" />
            Manage Sequence
          </div>
        </div>
      </div>
      <div
        style={{
          border: "1px solid #E7E7E7",
          marginBottom: "20px",
        }}
      />
      {loading ? (
        <div className="flex justify-center">
          <CircularProgress />
        </div>
      ) : (
        <div>
          <div className={`grid grid-cols-12  text-[#797979] text-[16px] px-8`}>
            <div className="col-span-2 ">
              <div className="text-[#191919] font-semibold mb-4">Question</div>
            </div>
            <div>
              <div className="text-[#191919] font-semibold text-center mb-4">
                {" "}
                Sequence
              </div>{" "}
            </div>
            <div>
              <div className="text-[#191919] font-semibold mb-4"> Option 1</div>{" "}
            </div>
            <div>
              <div className="text-[#191919] font-semibold mb-4"> Option 2</div>{" "}
            </div>
            <div>
              <div className="text-[#191919] font-semibold mb-4"> Option 3</div>
            </div>
            <div>
              <div className="text-[#191919] font-semibold mb-4"> Option 4</div>
            </div>
            <div>
              <div className="text-[#191919] font-semibold mb-4"> Option 5</div>
            </div>
            <div>
              <div className="text-[#191919] font-semibold mb-4"> Option 6</div>
            </div>
            <div>
              <div className="text-[#191919] font-semibold mb-4">
                Add Date Time
              </div>
            </div>
            <div>
              <div className="text-[#191919] font-semibold mb-4">
                {" "}
                Active Date Time
              </div>
            </div>
            <div>
              <div className="text-[#191919] font-semibold text-center mb-4">
                {" "}
                Status
              </div>
            </div>
          </div>
          <div>
            {questionList && questionList?.length > 0 ? (
              questionList.map((question, idx) => {
                return (
                  <div
                    key={idx}
                    className={`py-6 px-8 rounded-[16px] ${
                      idx % 2 === 0 ? "bg-white" : "bg-[#F9F9F9]"
                    }`}
                  >
                    <div
                      className={`grid grid-cols-12  text-[#797979] text-[14px] `}
                    >
                      <div className="col-span-2">
                        {question?.question || "--"}
                      </div>
                      <div className="text-center">
                        {question?.sequence || "--"}
                      </div>
                      <div>{question?.options[0] || "--"}</div>
                      <div>{question?.options[1] || "--"}</div>
                      <div>{question?.options[2] || "--"}</div>
                      <div>{question?.options[3] || "--"}</div>
                      <div>{question?.options[4] || "--"}</div>
                      <div>{question?.options[5] || "--"}</div>
                      <div>
                        {question?.createdAt
                          ? getDate(question?.createdAt)
                          : "--"}
                      </div>
                      <div>
                        {question?.updatedAt
                          ? getDate(question?.updatedAt)
                          : "--"}
                      </div>
                      <div className="text-center">
                        <Switch
                          checked={question?.status === "ACTIVE"}
                          onChange={() => {
                            if (
                              window.confirm(
                                `Are you sure you want to change status?`
                              )
                            ) {
                              updateQuestionStatus(
                                question.id,
                                question.status
                              );
                            }
                          }}
                          inputProps={{ "aria-label": "toggle status" }}
                          // style={{
                          //   color: hospital?.pmjaystatus ? "#017C57" : "#B0B0B0",
                          // }}
                          style={{ color: "#017C57" }}
                          sx={{
                            "& .MuiSwitch-thumb": {
                              backgroundColor:
                                question?.status === "ACTIVE"
                                  ? "#017C57"
                                  : "#D3D3D3",
                            },
                            "& .MuiSwitch-track": {
                              backgroundColor:
                                question?.status === "ACTIVE"
                                  ? "#017C57"
                                  : "#D3D3D3",
                            },
                          }}
                        />
                      </div>
                    </div>
                  </div>
                );
              })
            ) : (
              <div className="text-xl flex items-center justify-center mt-5 font-semibold h-[300px]">
                No Data Found
              </div>
            )}
          </div>
        </div>
      )}
      {addQuestion && (
        <AddSurveyQuestions
          getQuestionList={getQuestionList}
          setOpen={setAddQuestion}
          sequence={questionList?.length ? questionList.length : 0}
        />
      )}
      {manageSequence && (
        <ManageSequence
          questionList={questionList}
          setQuestionList={setQuestionList}
          setOpen={setManageSequence}
          getQuestionList={getQuestionList}
        />
      )}
    </div>
  );
};

export default ManageSurveyQuestions;
